export default "__VITE_ASSET__Db2$Wn$q__"